import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import moment from 'moment'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'Notice',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      loading: true,
      registerHash: Constants.RegisterHash,

      // テーブルオプション
      tableColumns: {
        '1': [
          'noticeDeliveryId',
          'deliveriedAt',
          'noticeTypeName',
          'deliveryToKbn',
          'deliveryStatus',
          'noticeContents',
          'noticeSenderName',
          'detailButton'
        ],
        '2': [
          'noticeId',
          'reservedDeliveryAt',
          'noticeTypeName',
          'deliveryToKbn',
          'reservedNoticeStatus',
          'noticeContents',
          'noticeSenderName',
          'detailButton'
        ],
        '3': [
          'noticeId',
          'createdAt',
          'noticeTypeName',
          'deliveryToKbn',
          'repeatedNoticeStatus',
          'noticeContents',
          'noticeSenderName',
          'detailButton'
        ],
      },
      tableData: [],
      tableOptions: {
        headings: {
          noticeDeliveryId: 'お知らせID',
          noticeId: 'お知らせID',
          deliveriedAt: '配信日時',
          reservedDeliveryAt: '配信日時',
          createdAt: '登録日時',
          noticeTypeName: 'お知らせ種別',
          deliveryToKbn: '配信先',
          deliveryStatus: 'ステータス',
          reservedNoticeStatus: 'ステータス',
          repeatedNoticeStatus: 'ステータス',
          noticeContents: '配信内容',
          noticeSenderName: '配信者',
          detailButton: ''
        },
        columnsClasses: {
          noticeDeliveryId: 'wp-5',
          noticeId: 'wp-5',
          deliveriedAt: '',
          reservedDeliveryAt: '',
          createdAt: '',
          noticeTypeName: '',
          deliveryToKbn: '',
          deliveryStatus: '',
          reservedNoticeStatus: '',
          repeatedNoticeStatus: '',
          noticeContents: '',
          noticeSenderName: '',
          detailButton: 'wp-5 has-button'
        },
        sortable: [
          'noticeDeliveryId',
          'noticeId',
          'deliveriedAt',
          'reservedDeliveryAt',
          'createdAt',
          'noticeTypeName',
          'deliveryToKbn',
          'deliveryStatus',
          'reservedNoticeStatus',
          'repeatedNoticeStatus',
          'noticeContents',
          'noticeSenderName'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // // 検索
      // searchService: '',
      // searchDate: '',
      // searchListType: '',

      // 検索されたか判別
      searched: false,
      listType: '',

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  created() {
    // お知らせ配信管理の場合、モード変更
    if (this.$route.name === 'NoticeList' && this.$route.query.token) {
      this.initNoticeBot(this.$route.query.token)
    }
  },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    if (this.isBot) {
      this.loadServiceInfo()
        .then(() => {
          this.$nextTick(() => {
            console.log('@@@', this.userServiceUuid)
            this.searchService = this.userServiceUuid
            this.searchDate = this.targetDateList[0].value
            this.searchListType = 1
            this.search()
          })
        })
        .catch(error => {
          this.showError(error || null)
        })
    } else {
      this.init()
    }
  },
  beforeDestroy() {
    if (this.$route.name !== 'NoticeDetail') {
      this.reset()
    }
  },
  computed: {
    ...mapState({
      categoryName: state => state.notice.categoryName,
      noticeModel: state => state.notice.noticeModel,
      serviceModel: state => state.notice.serviceModel,
      serviceDetailModel: state => state.notice.serviceDetailModel,

      // 検索
      filters: state => state.notice.filters,

      // お知らせ配信管理の場合、true
      isBot: state => state.noticeList.isBot,
      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept,
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      isAdmin: 'auth/isAdmin',
      isOperator: 'auth/isOperator',
      userServiceUuid: 'auth/userServiceUuid',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone'
    }),

    title () {
      return this.isBot
        ? 'お知らせ配信管理'
        : this.categoryName + '一覧'
    },

    // list
    serviceList () {
      return this.serviceModel
        .filter(item => item.serviceStatus === 1)
        .map(item => {
        return {
          value: item.serviceUuid,
          label: item.serviceName
        }
      })
    },
    targetDateList () {
      if (!this.selectedService) return []

      // 選択されたサービスの登録月を取得
      let timestamp = this.isAdmin
        ? this.serviceModel
          .find(item => item.serviceUuid === this.searchService).createdAt
        : this.serviceDetailModel.createdAt
      let startMonth = Utility.dateFormat(timestamp, 'YYYYMM')

      // 現在月を取得
      let date = moment()

      // 直近6ヶ月の場合
      let list = []
      list.push({
        value: date.format('YYYYMM'),
        label: date.format('YYYY年M月')
      })
      for (let i = 0, l = this.isAdmin ? 12 : 5; i < l; i++) {
        date.add(-1, 'M')
        if (date.format('YYYYMM') < startMonth) break
        list.push({
          value: date.format('YYYYMM'),
          label: date.format('YYYY年M月')
        })
      }
      return list
    },
    modeList () {
      return Constants.Notice.ListType
    },

    // table
    getTableColumns () {
      return this.tableColumns[this.listType] || []
    },
    tableLabel() {
      return Utility.getConstantsLabel(['Notice', 'ListType'], this.searchListType)
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // enable
    selectedService () {
      return this.searchService !== ''
    },
    disableSearchButton () {
      return this.searchListType === ''
    },

    // filter
    searchService: {
      get () {
        return this.filters.searchService
      },
      set (value) {
        this.setInputFilter({
          key: 'searchService',
          value: value
        })
      }
    },
    searchDate: {
      get () {
        return this.filters.searchDate
      },
      set (value) {
        this.setInputFilter({
          key: 'searchDate',
          value: value
        })
      }
    },
    searchListType: {
      get () {
        return this.filters.searchListType
      },
      set (value) {
        this.setInputFilter({
          key: 'searchListType',
          value: value
        })
      }
    },
  },
  watch: {
    searchService() {
      if (this.searched) {
        this.search();
      }
    },
    searchDate() {
      if (this.searched) {
        this.search();
      }
    },
    searchListType(to) {
      this.tableOptions.headings.reservedDeliveryAt = to === 2
        ? '予約配信日時'
        : '配信日時'

      if (this.searched) {
        this.search();
      }
    },
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 削除
      if (this.confirmKey === 'delete') {
        if (to) this.deleteData()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      loadModel: 'notice/loadModel',
      loadNoticeList: 'notice/loadNoticeList',
      reset: 'notice/reset',

      // お知らせ配信管理
      initNoticeBot: 'noticeList/init',
      loadServiceInfo: 'noticeList/loadServiceInfo',
      deleteNotice: 'notice/deleteNotice',
      showConfirm: 'confirm/show',
    }),
    ...mapMutations({
      setInputFilter: 'notice/setInputFilter',
    }),

    init () {
      this.loading = true

      let serviceParams = {}
      let serviceDetailParams = {}

      if (this.isOperator) {
        this.searchService = this.userServiceUuid
        serviceDetailParams.serviceUuid = this.searchService
      }

      // データ読出し
      this.loadModel({
        serviceParams: serviceParams,
        serviceDetailParams: serviceDetailParams,
      })
        // eslint-disable-next-line
        .then(res => {
          if (this.searchListType !== '') {
            this.search()

          // サービス運用者の場合、初期値を設定する
          } else if (this.isOperator) {
            this.searchDate = this.targetDateList[0].value
            this.searchListType = 1
            this.search()
          }

          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'deliveriedAt':
        case 'reservedDeliveryAt':
        case 'createdAt':
          return Utility.dateFormat(value, 'YYYY/MM/DD HH:mm')
        // case 'deliveryTo':
        //   return value.join('、')
        case 'deliveryToKbn':
          return Utility.getConstantsLabel(['ContentsApply', 'DeliveryToKbn'], value)
        case 'deliveryStatus':
          return Utility.getConstantsLabel(['Notice', 'DeliveryStatus'], value)
        case 'reservedNoticeStatus':
          return Utility.getConstantsLabel(['Notice', 'ReservedNoticeStatus'], value)
        case 'repeatedNoticeStatus':
          return Utility.getConstantsLabel(['Notice', 'RepeatedNoticeStatus'], value)
        case 'noticeContents':
          try {
            return JSON.parse(value).title ||
              JSON.parse(value).question ||
              Utility.getConstantsLabel(['Notice', 'KeikaiLevel'], JSON.parse(value).keikaiLevel) ||
              Constants.BlankValue
          } catch(e) {
            return Constants.BlankValue
          }
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 検索
    resetSearch () {
      if (this.isAdmin) {
        this.searchService = ''
        this.searchDate = ''
        this.searchListType = ''
      } else {
        this.searchDate = this.targetDateList[0].value
        this.searchListType = 1
      }

      this.searched = false

      this.init()
    },
    search () {
      this.loading = true

      // 絞り込みパラメータ
      let noticeParams = { filters: {} }
      if (this.searchService !== '')
        noticeParams.filters.serviceUuid = this.searchService
      if (this.searchDate !== '')
        noticeParams.filters.month = this.searchDate
      if (this.searchListType !== '')
        noticeParams.filters.listType = this.searchListType

      // データ読出し
      this.loadNoticeList({
        noticeParams: noticeParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.listType = this.searchListType
          this.tableData = $.extend(true, [], this.noticeModel)
          this.searched = true
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    detailItem (props) {
      const name = this.isBot
        ? 'NoticeListDetail'
        : 'NoticeDetail'
      this.$router.push({
        name: name,
        params: {
          noticeId: this.listType === 1
            ? String(props.row.noticeDeliveryUuid)
            : String(props.row.noticeUuid),
          listType: this.listType
        }
      })
    },
    deleteItem () {
      let deleteParams = {}
      if (this.searchService !== '')
        deleteParams.serviceUuid = this.searchService
      if (this.searchDate !== '')
        deleteParams.month = this.searchDate
      let date = this.searchDate
      let year = date.substring(0, 4);
      let month = date.substring(4, 6);
      this.showConfirm({
        key: 'delete',
        title: '',
        body: year + '年' + month + '月のお知らせを一括削除しますか？',
        acceptLabel: '削除'
      })
    },
    deleteData () {
      this.loading = true
      let noticeParams = {
        serviceUuid: this.searchService,
        deliveryStartMonth: this.searchDate
      }
      this.deleteNotice({
        noticeParams: noticeParams
      })
          .then(res => {
            this.tableData = []
            this.init()
          })
          .catch(error => {
            this.showError(error || null)
            this.loading = false
          })
    }
  }
}